export type HitSlop =
	| {
			top?: number;
			bottom?: number;
			left?: number;
			right?: number;
	  }
	| number;
const parseHitSlop = (hitSlop: HitSlop | undefined) => {
	if (typeof hitSlop === "number") {
		return {
			top: hitSlop,
			bottom: hitSlop,
			left: hitSlop,
			right: hitSlop,
		};
	}
	return hitSlop;
};
export default parseHitSlop;
